@for (star of stars; track star) {
  <mat-icon  [svgIcon]="star"></mat-icon>
}
